import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Slider from "../../mainPages/Home/slider/Slider.jsx";
import ServicesPage from '../../components/Services/Services.jsx';
import Blog from "../../components/Blog/Blog.jsx";
import Projects from '../../components/Projects/Projects.js';
import './home.css';
import Hero from "../../components/videos/Hero.js";
import ProductList from "../../components/ProductList/ProductList.js";

export default function Home() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const [viewed, setViewed] = useState({
    image1: false,
    image2: false,
    image3: false,
    image4: false,
  });

  const [currentSlide, setCurrentSlide] = useState(0);

  const images = [
    '/assets/comboslider.jpeg',
    '/assets/combo2.jpeg'
  ];

  // Initialize AOS for animations
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  // Auto-scroll logic for the gallery images
  useEffect(() => {
    const scrollElement = scrollRef.current;
    let scrollAmount = 0;

    const scroll = () => {
      if (scrollElement) {
        scrollAmount += 1;
        scrollElement.scrollLeft = scrollAmount;
        if (scrollAmount >= scrollElement.scrollWidth / 2) {
          scrollAmount = 0;
        }
      }
    };

    const interval = setInterval(scroll, 50); // Adjust speed for auto-scrolling

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const handleView = (image) => {
    setViewed((prev) => ({
      ...prev,
      [image]: true,
    }));
  };

  // Move to the previous slide
  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  // Move to the next slide
  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
      <Slider />

      {/* Trending on Vaira Maaligai Section */}
      <section className="trending" data-aos="fade-up">
        <h3>Trending on Vaira Maaligai</h3>
        <p>Trending on Vaira Maaligai - Classy Necklaces</p>
        <br />
        <Projects />
      </section>
      <section className='video-container'>
        < Hero />

      </section>

      {/* Our Latest Collection - Auto-Scrolling Gallery */}
      <section className="imageGallery" data-aos="fade-up">
        <h2>Exclusive Jewellery for You!</h2>
        <h3>Our Latest Collection</h3>
        <div className="imageWrapper" ref={scrollRef}>
          <div className="imageColumn">
            <img src="/assets/1image.jpg" alt="Image 1" className="galleryImage" />
            <img src="/assets/2image.jpg" alt="Image 2" className="galleryImage" />
            <img src="/assets/3images.jpg" alt="Image 3" className="galleryImage" />
            <img src="/assets/4imagess.jpg" alt="Image 4" className="galleryImage" />
            <img src="/assets/5image.jpg" alt="Image 5" className="galleryImage" />
            <img src="/assets/6image.jpg" alt="Image 6" className="galleryImage" />
            <img src="/assets/7image.jpg" alt="Image 7" className="galleryImage" />
            <img src="/assets/8image.jpg" alt="Image 8" className="galleryImage" />
            <img src="/assets/9image.jpg" alt="Image 9" className="galleryImage" />
            <img src="/assets/10image.jpg" alt="Image 10" className="galleryImage" />
          </div>
        </div>
      </section>
      <section id='productlist' style={{ padding: "0", margin: "0" }}> 
          <ProductList />
      </section>

      <section className="image-slider" style={{ padding: "0", margin: "0", position: 'relative', width: '100%', overflow: 'hidden' }}>
        <div className="slider-container" style={{ width: '100%', textAlign: 'center' }}>
          <img
            src={images[currentSlide]}
            alt="Slider Image"
            className="slider-image"
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: '500px',
              objectFit: 'cover',
              borderRadius: '10px',
            }}
          />
        </div>

        {/* Slider Navigation */}
        <button
          className="prev"
          onClick={prevSlide}
          style={{
            position: 'absolute',
            top: '50%',
            left: '10px',
            transform: 'translateY(-50%)',
            fontSize: '24px',
            background: 'rgba(0, 0, 0, 0.5)',
            color: 'white',
            border: 'none',
            padding: '10px 15px',
            cursor: 'pointer',
            borderRadius: '50%',
          }}
        >
          &#10094;
        </button>

        <button
          className="next"
          onClick={nextSlide}
          style={{
            position: 'absolute',
            top: '50%',
            right: '10px',
            transform: 'translateY(-50%)',
            fontSize: '24px',
            background: 'rgba(0, 0, 0, 0.5)',
            color: 'white',
            border: 'none',
            padding: '10px 15px',
            cursor: 'pointer',
            borderRadius: '50%',
          }}
        >
          &#10095;
        </button>
      </section>



      {/* Other Sections */}
     
      <Blog />
      <ServicesPage />
    </>
  );
}



